module.exports = __webpack_public_path__ + "static/media/blackseo2.ac151b5b.jpg";